import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import isError from "@mittwald/flow-lib/dist/errors/isError";
export const RawErrorRenderer = (props) => {
    const error = props.error;
    let output = `${error}`;
    if (isError(error)) {
        output = `
Error   : ${error.name}
Message : ${error.message}
==================
${error.stack}
                    `;
    }
    return _jsx(_Fragment, { children: output });
};
export default RawErrorRenderer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmF3RXJyb3JSZW5kZXJlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Vycm9yQm91bmRhcnkvY29tcG9uZW50cy9SYXdFcnJvclJlbmRlcmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxPQUFPLE1BQU0sd0NBQXdDLENBQUM7QUFHN0QsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQTJCLENBQUMsS0FBSyxFQUFFLEVBQUU7SUFDaEUsTUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQztJQUUxQixJQUFJLE1BQU0sR0FBRyxHQUFHLEtBQUssRUFBRSxDQUFDO0lBRXhCLElBQUksT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7UUFDbkIsTUFBTSxHQUFHO1lBQ0QsS0FBSyxDQUFDLElBQUk7WUFDVixLQUFLLENBQUMsT0FBTzs7RUFFdkIsS0FBSyxDQUFDLEtBQUs7cUJBQ1EsQ0FBQztJQUNwQixDQUFDO0lBRUQsT0FBTyw0QkFBRyxNQUFNLEdBQUksQ0FBQztBQUN2QixDQUFDLENBQUM7QUFFRixlQUFlLGdCQUFnQixDQUFDIn0=